import { SAVE_LUMP_SUM, SAVE_LUMP_SUM_FAILURE } from './actions';

export const initialState = {
  error: undefined
};

function lumpSumReducer(state = initialState, action) {
  switch (action.type) {
    case SAVE_LUMP_SUM:
      return {
        ...state,
        error: undefined
      };
    case SAVE_LUMP_SUM_FAILURE:
      return {
        ...state,
        error: action.error
      };
    default:
      return state;
  }
}

export default lumpSumReducer;
